import ButtonLink from 'dyl-components/atoms/ButtonLink';
import DateTimeUtils from 'dyl-components/utils/DateTimeUtils';
import React, { useState } from 'react';
import { Grid, Icon, Popup } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import VoicemailPlayback from '../VoicemailPlayback';

const CALL_TYPE_ICONS = {
    sequence: "fas fa-sitemap",
    task: "fa-solid fa-clipboard-check",
    callback: "fas fa-file-user",
    newlead: "fas fa-file-user",
    dialer: "fas fa-megaphone"
}


const DIRECTION_ICONS = {
    inbound: "fa-solid fa-phone-arrow-down-left",
    outbound: "fa-solid fa-phone-arrow-up-right",
    internal: "fa-solid fa-people-pants-simple"
}

const PERSON_TYPE_ICON = {
    person: "fa-solid fa-user",
    household: "fa-solid fa-house-chimney",
    business: "fa-solid fa-buildings",
}

const OfficeViewRecentItem = ({ 
    recent,
    onRecentCallClick,
    onMarkVoicemailAsListened,
    onClickToDialList,
    isPhoneSystemSupported,
    logActivityForm,
    onSkipCall
}) => {
    const [isVoicemailPlaybackOpen, setIsVoicemailPlaybackOpen] = useState(false);
    const [isCallActivityFormOpen, setIsCallActivityFormOpen] = useState(false);
    const isPrimaryPhone = onSkipCall ? recent.contact?.phone?.main : (recent?.contacts?.length && recent?.contacts?.[0]?.primary);
    return (
        <Grid onClick={() => {
            if (!isVoicemailPlaybackOpen) {
                onRecentCallClick();
            }
        }} verticalAlign="middle" className='OfficeViewRecents__element'>
            <Grid.Row>
                <Grid.Column width={3}>
                    {onSkipCall ? (
                        recent.time ? <div>
                            <div><b>{DateTimeUtils.formatEpoch(recent.time, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                            <div>{DateTimeUtils.formatEpoch(recent.time, DateTimeUtils.TIME_FORMAT)}</div>
                        </div> : "Call Now"
                    ) : (
                        <div style={{display: 'flex', gap: 10}}>
                            <Popup
                                trigger={ <div className={`RecentCalls__missedCallBorder ${!recent.unreturned ? "RecentCalls__missedCallBorder--invisible" : ""}`} /> }
                                content={"Call Not Returned"}
                                inverted
                                disabled={recent.not_returned}
                            />
                            <div>
                                <div><b>{DateTimeUtils.formatEpoch(recent.start_ts, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                                <div>{DateTimeUtils.formatEpoch(recent.start_ts, DateTimeUtils.TIME_FORMAT)}</div>
                            </div>
                        </div>
                    )}
                </Grid.Column>
                <Grid.Column width={6}>
                    <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                        <Icon className={`${CALL_TYPE_ICONS[recent.call_type] || ""}`} />
                        {!onSkipCall && <Icon className={`${DIRECTION_ICONS[recent.direction] || ""}`} />}
                        <div>
                            <div>
                                {onSkipCall ? (
                                    <>
                                        {recent?.contact && recent?.contact?.first_name && (
                                            <Icon className={"fa-solid fa-user"} style={{marginRight: 7}} />
                                        )}
                                        <ButtonLink style={{paddingLeft: 0, maxWidth: '187px'}} className='ClippedContent'>{recent.contact?.first_name + " " + recent.contact?.last_name || "Unknown"}</ButtonLink>
                                    </>
                                ) : (
                                    <>
                                        {recent?.contacts?.[0] && recent?.contacts?.[0]?.name && (
                                            <Icon className={PERSON_TYPE_ICON[recent.contacts?.[0]?.type || ""]} size={"small"} style={{marginRight: 7}} />
                                        )}
                                        <ButtonLink style={{paddingLeft: 0, maxWidth: '187px'}} className='ClippedContent'>{recent.contacts?.[0]?.name || recent.contacts?.[0]?.contact_name || recent.users?.[0]?.name || recent.destination?.label || "Unknown"}</ButtonLink>
                                    </>
                                )}
                            </div>
                            {!onSkipCall && <span className={`RecentCalls__resultColor${!!recent.connected_ts ? "--green" : "--red"}`}>{recent.system_result}</span>}
                        </div>
                    </div>
                </Grid.Column>
                <Grid.Column width={4}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        {onSkipCall ? (
                            recent.contact?.phone?.phone && (
                                <>
                                    <span>{PhoneUtil.formatPhoneNumber(recent.contact?.phone?.phone)}</span>
                                    {isPrimaryPhone ? <Icon name='star' color='blue' style={{ marginLeft: 4 }} /> : ""}
                                </>
                            )
                        ) : (
                            <>
                                <span>{recent.contacts.length > 0 ? PhoneUtil.formatPhoneNumber(recent.contacts?.[0]?.phone) : recent.users?.[0]?.extension ? `Ext. ${recent.users?.[0]?.extension}` : recent.destination?.label}</span>
                                {isPrimaryPhone ? <Icon name='star' color='blue' style={{ marginLeft: 4 }} /> : ""}
                            </>
                        )}
                    </div>
                </Grid.Column>
                <Grid.Column width={2}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 7}}>
                        {isPhoneSystemSupported ?
                            <ButtonLink disabled={recent?.contacts?.[0] && recent?.contacts?.[0]?.archived || false} onClick={(event) => {
                                event.stopPropagation();
                                onClickToDialList();
                            }}>
                                <Icon className='fa-solid fa-phone' size={"large"} />
                            </ButtonLink>
                            : <Popup
                                    className="AddForm"
                                    trigger={
                                        <ButtonLink>
                                            <Icon
                                                className="fa-solid fa-phone OfficeView__icons"
                                                size={"large"}
                                                primary
                                            />
                                        </ButtonLink>
                                    }
                                    content={() =>
                                        logActivityForm?.(
                                            {
                                                id: onSkipCall ? recent?.contact?.id : recent?.contacts?.[0]?.contact_id || recent.contacts?.[0]?.account_id,
                                            },
                                            false,
                                            recent?.contacts?.[0]?.contact_id ? true : false,
                                            () => setIsCallActivityFormOpen(false),
                                            true
                                        )
                                    }
                                    closeOnDocumentClick={false}
                                    open={isCallActivityFormOpen}
                                    onClose={() => setIsCallActivityFormOpen(false)}
                                    onOpen={() => setIsCallActivityFormOpen(true)}
                                    on="click"
                                    position="bottom left"
                                    pinned
                                    basic
                                    wide
                                />}
                        {onSkipCall ? (
                            <ButtonLink onClick={(event) => {
                                if(recent.time){
                                    event.stopPropagation(); 
                                    onSkipCall(recent)
                                }
                            }} disable={!recent.time}>
                                <Icon name='fas fa-xmark' color='red' size={"big"} disabled={!recent.time} />
                            </ButtonLink>
                        ) : (
                            <ButtonLink onClick={(event) => event.stopPropagation()} disabled>
                                <Icon className='fa-solid fa-split' size={"large"} />
                            </ButtonLink>
                        )}
                        {!onSkipCall && (
                            <Popup
                                style={{minWidth:400}}
                                trigger={
                                    <Icon className={`fa-solid fa-voicemail ${!recent.voicemail ? `RecentCalls__missedCallBorder--invisible` : ""}`} size="large" color="primary" />
                                }
                                on="click"
                                content={
                                    <VoicemailPlayback
                                        onClose={(event) => {
                                            event.stopPropagation();
                                            setIsVoicemailPlaybackOpen(false)
                                        }}
                                        className={`audio-playback-${recent.call_uuid}`}
                                        link={recent.voicemail}
                                        fileName="Voicemail"
                                        isVoicemail
                                        onMarkAsListened={() => onMarkVoicemailAsListened(recent?.call_uuid)}
                                    />
                                }
                                position="bottom center"
                                open={isVoicemailPlaybackOpen}
                                onOpen={(event) => {
                                    event.stopPropagation();
                                    setIsVoicemailPlaybackOpen(true);
                                }}
                            />
                        )}
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}

export default OfficeViewRecentItem;
